import { Component, Input } from '@angular/core';
import { MaterialModel } from '@evorait/pace-core';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-confirmation-material-stock-details-expandable',
    templateUrl: './confirmation-material-stock-details-expandable.component.html',
    styleUrls: ['./confirmation-material-stock-details-expandable.component.scss'],
})
export class ConfirmationMaterialStockDetailsExpandableComponent {
    @Input() public material: MaterialModel;
    @Input() public isModelNotification: boolean;

    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    public isCollapsed = true;
}
